module.exports = "/_next/static/media/5a69795a00e712d993effb25d0f8a00f.png";